export default __webpack_public_path__ + "static/media/img-placeholder.e184fa13.jpg";